import { render, staticRenderFns } from "./givingBottomBannerMobile.vue?vue&type=template&id=0ae8cfce&scoped=true&"
import script from "./givingBottomBannerMobile.vue?vue&type=script&lang=js&"
export * from "./givingBottomBannerMobile.vue?vue&type=script&lang=js&"
import style0 from "./givingBottomBannerMobile.vue?vue&type=style&index=0&id=0ae8cfce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae8cfce",
  null
  
)

export default component.exports